export default __webpack_public_path__ + "static/media/milkshake.b6c29c77.jpg";